import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './utils/rem'

import VideoPlayer from 'vue-video-player'
import VueParticles from 'vue-particles'
import vueScrollwatch from "vue-scrollwatch"
Vue.use(vueScrollwatch)
Vue.use(VueParticles)
Vue.use(VideoPlayer)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
